import React from 'react';
import { Trans } from '@lingui/macro';
import { Link } from '@reach/router';
import { linkTo } from 'utils/links';
import Config from 'config';
import classNames from 'classnames';

import Image from 'components/Image';
import Panel from 'components/Panel';
import Logo from 'theme/images/logo.svg';

export default function AuthScreen({ children }) {
  return (
    <div className="h-screen overflow-auto">
      <div className="bg-main-menu">
        <div className="container text-default px-6 pt-6 pb-8 uppercase flex lg:px-24">
          <Link to={linkTo('/discover')} className="flex items-center">
            <Image src={Config.app.APP_LOGO ? Config.app.APP_LOGO : Logo} className={classNames('Layout_Auth_logo block', { 'Layout_Auth_logo_custom': !!Config.app.APP_LOGO })} /> {!Config.app.APP_LOGO && <span className="block font-sans ml-2 text-xl">{Config.app.APP_TITLE}</span>}
          </Link>
        </div>
      </div>
      <div className="Layout_Fullscreen container">
        <div className="flex flex-col my-4 mx-6 md:flex-row lg:mt-12 lg:px-24 lg:mx-0">
          <div className="md:flex-1 md:mt-12 ">
            <h1 className="text-default text-2xl leading-tight md:text-4xl"><Trans>Join our community<span className="hidden md:inline"><br className="hidden md:block" /> and listen to thousands<br className="hidden md:block" /> of Independent Musicians.</span></Trans></h1>
            <p className="mt-2 text-secondary leading-tight text-base md:text-xl"><Trans>If you are a musician, share your music<br className="hidden md:block" /> with the world and make new fans.</Trans></p>
          </div>
          <div className="mt-8 md:mt-12 md:w-1/3">
            <Panel>
              {children}
            </Panel>
          </div>
        </div>
      </div>
    </div>
  );
}
